import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const naver: Platform = {
  id: 'naver',
  name: 'Naver',
  iconIndex: PlatformRegistry.naver.index,
  color: PlatformRegistry.naver.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://share.naver.com/web/shareView.nhn', {
      url: content.url,
      title: content.title,
    });
  },
};

